import React, { useState, useEffect } from "react";
import { Button, Form, Row, Col, Toast } from "react-bootstrap";
import { IoMdDoneAll, IoIosClose } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { _HttpServices } from "../../_services/_HttpServices";
import { connect } from "react-redux";
import { logoutSuccess } from "../../actions/user/userActions";
import { Footer } from "../../components/Footer";
const ChangePassword = ({ dispatch, loading, hasErrors }) => {
	// const history = useHistory();
	const intialstate = {
		oldPassword: "",
		newPassword: "",
		confirmPassword: "",
	};
	const [changePassword, setChangePassword] = useState(intialstate);
	const [userPassword, setUserPassword] = useState("");
	const [disableSubmit, setDisableSubmit] = useState(true);
	const [validated, setValidated] = useState(false);
	const [isPwdMatch, setIsPwdMatch] = useState(false);
	const [isOldPwdErr, setIsOldPwdErr] = useState(false);
	const [isPwdRegex, setIsPwdRegex] = useState(false);
	const [showToaster, setShowToaster] = useState(false);
	const history = useHistory();

	useEffect(() => {
		if (localStorage.getItem("userData")) {
			const userData = localStorage.getItem("userData");
			setUserPassword(JSON.parse(userData).Password);
		}
	}, []);

	const handleInputChange = (event) => {
		const { name, value } = event.target;
		// if(changePassword.confirmPassword === changePassword.newPassword){
		//     setIsPwdMatch(false);
		// }
		setChangePassword({ ...changePassword, [name]: value });
		if (
			changePassword.confirmPassword !== "" &&
			changePassword.oldPassword !== "" &&
			changePassword.newPassword !== ""
		) {
			setDisableSubmit(false);
		} else {
			setDisableSubmit(true);
		}
		if (name === "newPassword") {
			const re =
				/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
			if (re.test(value)) {
				setIsPwdRegex(false);
			} else {
				setIsPwdRegex(true);
			}
		}

		if (
			changePassword.oldPassword.trim() !== "" &&
			changePassword.newPassword.trim() !== "" &&
			changePassword.confirmPassword.trim() !== ""
		) {
			setDisableSubmit(false);
		} else {
			setDisableSubmit(true);
		}
	};

	const submitHandler = (event) => {
		setIsOldPwdErr(false);
		setValidated(false);
		const form = event.currentTarget;
		if (form.checkValidity() === false) {
			event.preventDefault();
			event.stopPropagation();
		}

		event.preventDefault();
		if (changePassword.oldPassword !== "") {
			if (changePassword.newPassword === changePassword.confirmPassword) {
				setIsPwdMatch(false);
				const formModel = {
					existingPassword: changePassword.oldPassword,
					userId: JSON.parse(localStorage.getItem("userData")).Id,
					NewPassword: changePassword.newPassword,
				};
				if (isPwdRegex) {
					return false;
				}
				_HttpServices
					.postData(
						`Api/user/ChangePassword?existingPassword=${formModel.existingPassword}&&userId=${formModel.userId}&&NewPassword=${formModel.NewPassword}`,
						{}
					)
					.then((data) => {
						if (data.data !== "") {
							setShowToaster(true);
							setChangePassword(intialstate);
							setTimeout(() => {
								dispatch(logoutSuccess());
							}, 3000);
						} else {
							setShowToaster(false);
						}
					})
					.catch((e) => {
						if (e.response !== undefined && e.response.status === 400) {
							setIsOldPwdErr(true);
							setValidated(true);
						}
					});
			} else {
				setIsPwdMatch(true);
			}
		} else {
			setValidated(true);
		}
	};

	return (
		<React.Fragment>
			<section className="content">
				{/* Toaster */}
				<Toast
					onClose={() => setShowToaster(false)}
					show={showToaster}
					delay={1500}
					autohide
					className="custom-toaster"
				>
					{/* <Toast.Header>
                        <img
                            src="holder.js/20x20?text=%20"
                            className="rounded mr-2"
                            alt=""
                        />
                        <strong className="mr-auto">Woohoo!!</strong>
                    </Toast.Header> */}
					<Toast.Body>Password changed successfully</Toast.Body>
				</Toast>

				<div className="page-title">
					<h2 className="h2">Change Password</h2>
				</div>

				<Row>
					<Col md={6}>
						<div className="card pt-2">
							<div className="card-body">
								<Form noValidate validated={validated} onSubmit={submitHandler}>
									<Form.Group className="pos-rl mb-4">
										<Form.Label htmlFor="oldPassword">
											Old Password<span className="required">*</span>
										</Form.Label>
										<Form.Control
											type="password"
											required
											name="oldPassword"
											onChange={handleInputChange}
											value={changePassword.oldPassword}
											className={isOldPwdErr ? "is-invalid" : null}
											maxLength={50}
										/>
										{!isOldPwdErr && (
											<Form.Control.Feedback type="invalid">
												Old password is required.
											</Form.Control.Feedback>
										)}
										{isOldPwdErr && (
											<Form.Control.Feedback type="invalid">
												{/* Please enter valid old password. */}
												Incorrect Password.
											</Form.Control.Feedback>
										)}
									</Form.Group>
									<Form.Group className="pos-rl mb-4">
										<Form.Label htmlFor="newPassword">
											New Password<span className="required">*</span>
										</Form.Label>
										<Form.Control
											type="password"
											required
											name="newPassword"
											onChange={handleInputChange}
											value={changePassword.newPassword}
											className={isPwdRegex ? "is-invalid" : null}
											maxLength={50}
										/>
										<Form.Text id="newPassword" muted>
											New password should be minimum 8 characters with a mixture
											of upper case & lower case letters, one numeric and one
											special character.
										</Form.Text>
										{!isPwdRegex && (
											<Form.Control.Feedback type="invalid">
												New password is required.
											</Form.Control.Feedback>
										)}
										{isPwdRegex && (
											<Form.Control.Feedback type="invalid">
												{/* New password is not meeting requirement. */}
												{/* Entered "New password" is not meeting the above rules. */}
												Your password does not satisfy the current policy
												requirements.
											</Form.Control.Feedback>
										)}
									</Form.Group>
									<Form.Group className="pos-rl mb-4">
										<Form.Label htmlFor="confirmPassword">
											Confirm Password<span className="required">*</span>
										</Form.Label>
										<Form.Control
											type="password"
											required
											name="confirmPassword"
											onChange={handleInputChange}
											value={changePassword.confirmPassword}
											className={isPwdMatch ? "is-invalid" : null}
											maxLength={50}
										/>
										{!isPwdMatch && (
											<Form.Control.Feedback type="invalid">
												Confirm password is required.
											</Form.Control.Feedback>
										)}
										{isPwdMatch && (
											<Form.Control.Feedback type="invalid">
												{/* Confirm password and new password are not matched. */}
												New password and Confirm password should be same.
											</Form.Control.Feedback>
										)}
									</Form.Group>
									<Form.Group className="text-right mt-4">
										<Button
											type="submit"
											disabled={showToaster || disableSubmit}
										>
											<IoMdDoneAll className="icon btn-icon" />
											Submit
										</Button>
										<Button
											variant="danger"
											className="ml-3"
											onClick={() => history.goBack()}
										>
											<IoIosClose className="icon btn-icon" />
											Cancel
										</Button>
									</Form.Group>
								</Form>
							</div>
						</div>
					</Col>
				</Row>

				<Footer />
			</section>
		</React.Fragment>
	);
};

// export default ChangePassword;
// Map Redux state to React component props
const mapStateToProps = (state) => ({
	login: state.users.login,
	loading: state.clients.loading,
	hasErrors: state.clients.hasErrors,
});

// Connect Redux to React
export default connect(mapStateToProps)(ChangePassword);
